let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("4waaI"), load("h7oxu"), load("6wr18"), load("ffEVr"), load("4Kqu1")]).then(() => parcelRequire('i6jK3'));